import { z } from "zod";
//#region src/api/orpc/util/queryParams.ts
/** Normalize a union of `string | string[]` (as produced by oRPC bracket
* notation or comma-separated query strings) into a cleaned string[]: split
* on comma, trim each item, drop empties. Pure. */
function splitCsvOrArray(value) {
	return (Array.isArray(value) ? value : [value]).flatMap((item) => item.split(",")).map((item) => item.trim()).filter((item) => item.length > 0);
}
/** Non-throwing `BigInt` coerce — returns null when the string can't be parsed. */
function tryParseBigint(s) {
	try {
		return BigInt(s);
	} catch {
		return null;
	}
}
/** Size-validate + per-element coerce a list of id strings into bigints. Reports
* failures to the zod context via `ctx.addIssue`. Intended for use inside a
* `z.transform((value, ctx) => ...)`. */
function parseBigintList(parts, ctx, opts) {
	const label = opts.field ?? "ids";
	if (parts.length < opts.min || parts.length > opts.max) {
		ctx.addIssue({
			code: "custom",
			message: `${label} must contain between ${opts.min} and ${opts.max} values`,
			path: []
		});
		return z.NEVER;
	}
	const result = [];
	for (const p of parts) {
		const id = tryParseBigint(p);
		if (id == null) {
			ctx.addIssue({
				code: "custom",
				message: `Invalid bigint in ${label}: ${p}`,
				path: []
			});
			return z.NEVER;
		}
		result.push(id);
	}
	return result;
}
//#endregion
export { parseBigintList, splitCsvOrArray, tryParseBigint };
